// extracted by mini-css-extract-plugin
export default {"readOnlySection":"_KPS2RHWvFn_mIGIzM91","isReadOnly":"VelwaSFXuYlMKddqfep8","clickable":"de7jJwDkEvBVf5eKRCKA"};